import role from 'Helpers/role/mixin'

const GlobalMethods = {
  install(Vue) {
    Vue.mixin(role)
  },
}

export default GlobalMethods
